module.exports = __webpack_public_path__ + "static/img/news-wz1.d375463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/news-wz1.jpg
// module id = 2fQV
// module chunks = 0